import styled from "@emotion/styled";
import { RequiredThemeKeys } from "../../../../util/theme";
import { formInputTheme } from "../../../textinput/styled/formInputTheme";

interface DatePickerTextInputPlaceholderStyledProps {
    themeMode: RequiredThemeKeys;
    validationState: "error" | undefined;
}

export const DatePickerTextInputPlaceholderStyled = styled("div")<DatePickerTextInputPlaceholderStyledProps>`
    position: absolute;
    box-sizing: border-box;
    outline: none;

    // This needs to show on top of the input, but not be clickable.
    z-index: 1;
    pointer-events: none;

    font-weight: ${({ themeMode }) => formInputTheme.fontWeight(themeMode)};
    font-size: ${({ themeMode }) => formInputTheme.fontSize.box(themeMode)};
    padding-top: 11px;
    padding-left: calc(2px + ${getPadding});
`;

function getPadding({ themeMode, validationState }: DatePickerTextInputPlaceholderStyledProps) {
    if (validationState === "error") {
        return formInputTheme.padding.left.error(themeMode);
    } else {
        return formInputTheme.padding.left.rest(themeMode);
    }
}
